// extracted by mini-css-extract-plugin
export default {"container":"dashboard_container__8Kvpf","header":"dashboard_header__DEVuQ","configureButton":"dashboard_configureButton__f7D-g"};